<template>
    <div class="o-importantContact u-py20 u-overflowYAuto">
        <div class="o-importantContact__inner u-container u-overflowHidden">
            <Contact :item="contact" />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import api from '../services/api';
import Contact from '../components/molecules/Contact.vue';

const contact = ref({});
const loading = ref(true);
const currentId = inject('currentId');

const fetchImportantContact = async () => {
    try {
        const response = await api.get(`/important-contact/${currentId.value}`);

        if (response.status === 200) {
            contact.value = response.data;
        }
    } catch (error) {
        console.error('Error fetching important contact:', error);
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    fetchImportantContact();
});
</script>